import createIcon from '../../createIcon';

/**
 * @component @name TaxiAlert
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAxNy41QzYuODI4NDMgMTcuNSA3LjUgMTYuODI4NCA3LjUgMTZDNy41IDE1LjE3MTYgNi44Mjg0MyAxNC41IDYgMTQuNUM1LjE3MTU3IDE0LjUgNC41IDE1LjE3MTYgNC41IDE2QzQuNSAxNi44Mjg0IDUuMTcxNTcgMTcuNSA2IDE3LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUgMTcuNUMxNS44Mjg0IDE3LjUgMTYuNSAxNi44Mjg0IDE2LjUgMTZDMTYuNSAxNS4xNzE2IDE1LjgyODQgMTQuNSAxNSAxNC41QzE0LjE3MTYgMTQuNSAxMy41IDE1LjE3MTYgMTMuNSAxNkMxMy41IDE2LjgyODQgMTQuMTcxNiAxNy41IDE1IDE3LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuNSAxMy41VjE4LjVIMy41VjEzLjVIMTcuNUMxNS41OSAxMy41IDEzLjg3IDEyLjc0IDEyLjYxIDExLjVINC4zMUw1LjM1IDguNUgxMC43OUMxMC42IDcuODcgMTAuNSA3LjIgMTAuNSA2LjVDMTAuNSA1LjggMTAuNiA1LjEzIDEwLjc5IDQuNUg3LjVWNi41SDVDNC4zNCA2LjUgMy43OSA2LjkyIDMuNTggNy41MUwxLjUgMTMuNVYyMS41QzEuNSAyMi4wNSAxLjk1IDIyLjUgMi41IDIyLjVIMy41QzQuMDUgMjIuNSA0LjUgMjIuMDUgNC41IDIxLjVWMjAuNUgxNi41VjIxLjVDMTYuNSAyMi4wNSAxNi45NSAyMi41IDE3LjUgMjIuNUgxOC41QzE5LjA1IDIyLjUgMTkuNSAyMi4wNSAxOS41IDIxLjVWMTMuNUwxOS40MSAxMy4yM0MxOC44IDEzLjQgMTguMTYgMTMuNSAxNy41IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTcuNSAxLjVDMTQuNzQgMS41IDEyLjUgMy43NCAxMi41IDYuNUMxMi41IDkuMjYgMTQuNzQgMTEuNSAxNy41IDExLjVDMjAuMjYgMTEuNSAyMi41IDkuMjYgMjIuNSA2LjVDMjIuNSAzLjc0IDIwLjI2IDEuNSAxNy41IDEuNVpNMTggOS41SDE3VjguNUgxOFY5LjVaTTE4IDcuNUgxN1YzLjVIMThWNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TaxiAlert = createIcon('TaxiAlert', [
  [
    'path',
    {
      d: 'M6 17.5C6.82843 17.5 7.5 16.8284 7.5 16C7.5 15.1716 6.82843 14.5 6 14.5C5.17157 14.5 4.5 15.1716 4.5 16C4.5 16.8284 5.17157 17.5 6 17.5Z',
      key: '1s3ibt',
    },
  ],
  [
    'path',
    {
      d: 'M15 17.5C15.8284 17.5 16.5 16.8284 16.5 16C16.5 15.1716 15.8284 14.5 15 14.5C14.1716 14.5 13.5 15.1716 13.5 16C13.5 16.8284 14.1716 17.5 15 17.5Z',
      key: '166dkh',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 13.5V18.5H3.5V13.5H17.5C15.59 13.5 13.87 12.74 12.61 11.5H4.31L5.35 8.5H10.79C10.6 7.87 10.5 7.2 10.5 6.5C10.5 5.8 10.6 5.13 10.79 4.5H7.5V6.5H5C4.34 6.5 3.79 6.92 3.58 7.51L1.5 13.5V21.5C1.5 22.05 1.95 22.5 2.5 22.5H3.5C4.05 22.5 4.5 22.05 4.5 21.5V20.5H16.5V21.5C16.5 22.05 16.95 22.5 17.5 22.5H18.5C19.05 22.5 19.5 22.05 19.5 21.5V13.5L19.41 13.23C18.8 13.4 18.16 13.5 17.5 13.5Z',
      key: 'oq5m5e',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 1.5C14.74 1.5 12.5 3.74 12.5 6.5C12.5 9.26 14.74 11.5 17.5 11.5C20.26 11.5 22.5 9.26 22.5 6.5C22.5 3.74 20.26 1.5 17.5 1.5ZM18 9.5H17V8.5H18V9.5ZM18 7.5H17V3.5H18V7.5Z',
      key: '571l7h',
    },
  ],
]);

export default TaxiAlert;
